import { IonAccordion, IonItem } from "@ionic/react";
import React, { useState } from "react";
import { Comp } from "../../types/comp";
import ListTheme from "../List/ListTheme";
import { loadTheme } from "./Competence";

interface IThemesProps {
  comp: Comp;
}

const ThemesList: React.FC<IThemesProps> = ({ comp }) => {
  const [themes, setThemes] = useState([]);

  const loadData = async () => {
    if (themes.length === 0) {
      await loadTheme(comp.themesID).then((res) => {
        setThemes(
          res.map((t: any) => ({
            id_videos: t.id_videos[0],
            picture_url: t.picture_url,
            _id: t._id,
          }))
        );
      });
    }
  };

  return (
    <IonAccordion onClick={async () => await loadData()}>
      <IonItem slot="header">
        <span className="bold secondary-text">{comp.name.split("-")[0]}</span>
        <span className="no-bold desc-comp">
          {comp.name.split("-").slice(1).join("-")}
        </span>
      </IonItem>
      <div slot="content">
        <ListTheme theme={themes} compID={comp.id} />
      </div>
    </IonAccordion>
  );
};

export default ThemesList;
